import React from "react";

const MyCircleList = ({ usersCircles, companyIdToParam }) => (
  <div className="h-100 shadow-sm pb-3">
    <div className="container col-md-8 col-lg-6">
      <ul className="list-group list-group--event ">
        {usersCircles.map((usersCircle, index) => (
          <li
            key={index}
            className="list-group-item list-group--item-event border-top-0 pt-3 pr-0 pl-0"
          >
            <a
              className="hov--default"
              href={companyIdToParam ? `/community/${companyIdToParam}/circle/${usersCircle.circle.id}` : `/circle/${usersCircle.circle.id}`}
            >
              <div className="row align-items-center">
                <div className="col-6">
                  <img
                    className="card-img-top w-100 card-img-top--list_profileevent"
                    src={usersCircle.circle.main_image_url}
                  />
                </div>
                <div className="col pl-0 position-relative">
                  {usersCircle.is_owner ? (
                    <p className="btn-sm text-fz-xs bg-orange text-white mb-0 float-right">
                      オーナー
                    </p>
                  ) : ( 
                    usersCircle.manager_status ? (
                      <p className="btn-sm text-fz-xs bg-orange text-white mb-0 float-right">
                        クリエイター
                      </p>
                    ) : ""
                  )}
                  <h6 className="h6--list-title position-relative mb-2 line-2">
                    {usersCircle.circle.name}
                  </h6>
                  <div className="row no-gutters">
                    <p className="mb-2 icon icon-area mr-2_5">
                      {usersCircle.circle.pref}
                    </p>
                    <p className="mb-2 icon icon-member">
                      {usersCircle.circle.real_num_of_members}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default MyCircleList;
